import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import './VisitorTable.css';
import TrackingService from '../../services/TrackingService';

const VisitorTable = ({ visitors: propVisitors, onVisitorClick }) => {
  const [visitors, setVisitors] = useState(propVisitors || []);
  
  useEffect(() => {
    // If no visitors are provided as props, fetch them
    if (!propVisitors || propVisitors.length === 0) {
      const fetchVisitors = async () => {
        try {
          const visitorData = await TrackingService.getVisitorData();
          setVisitors(visitorData);
        } catch (error) {
          console.error('Failed to fetch visitor data:', error);
        }
      };
      
      fetchVisitors();
    } else {
      setVisitors(propVisitors);
    }
  }, [propVisitors]);

  const formatDuration = (milliseconds) => {
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    if (hours > 0) {
      return `${hours}h ${minutes % 60}m`;
    }
    if (minutes > 0) {
      return `${minutes}m ${seconds % 60}s`;
    }
    return `${seconds}s`;
  };

  if (!visitors || visitors.length === 0) {
    return (
      <div className="empty-table-message">
        <p>No visitor data available</p>
      </div>
    );
  }

  return (
    <div className="visitor-table">
      <table>
        <thead>
          <tr>
            <th>Visitor ID</th>
            <th>First Seen</th>
            <th>Last Active</th>
            <th>Sessions</th>
            <th>Pages Viewed</th>
            <th>Time on Site</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {visitors.map(visitor => (
            <tr key={visitor.id} onClick={() => onVisitorClick(visitor)}>
              <td>{visitor.id}</td>
              <td>{format(new Date(visitor.firstSeen), 'PPp')}</td>
              <td>{format(new Date(visitor.lastActive), 'PPp')}</td>
              <td>{visitor.sessionCount}</td>
              <td>{visitor.pageViews}</td>
              <td>{formatDuration(visitor.timeOnSite)}</td>
              <td>
                <button onClick={(e) => {
                  e.stopPropagation();
                  onVisitorClick(visitor);
                }}>
                  View Details
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VisitorTable; 